const list = {
    or: 'ou',
    and: 'e',
    separator: ',',
};
export default Object.freeze(list);
